import json from "@/data/copy/projects-page.json";
import { createCopyGetter } from "./localize-copy";

export const getProjectsPageCopy = /*#__PURE__*/ createCopyGetter(json);
